import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { Avatar } from '../../../../../components/UI'

import { selectRole } from '../../../../../routing/fetchingfunction/user/user.reducer'

import { getUserName } from '../../../../../helpers'

import { classLevels, TUTOR_ROLE } from '../../../../../constants'

const PastClass = ({ pastClass }) => {
  const role = useSelector(selectRole)

  const isTutor = role === TUTOR_ROLE

  const classBanner = (pastClass.availability_calendar_detail || pastClass.availability_calendar)
    .class_banner

  const classLevel =
    classLevels.find((level) => level.value === classBanner?.class_banner_level) || classLevels[2]

  return (
    <div className="p-[20px] w-full bg-[#FEEBDD] rounded-[4px] mb-[10px] flex items-center">
      <div className="flex items-center">
        <h5 className="mr-[8px] text-2xl font-bold text-[#F67443] font-Inter">
          {classBanner.class_banner_category.name}
        </h5>

        <span className="border-[1px] border-[#F79009] bg-[#FCF3E8] rounded-[8px] px-[8px] h-[24px] flex items-center justify-center text-xs font-semibold text-[#F79009] font-Inter">
          {classLevel.label}
        </span>
      </div>

      <div className="ml-auto flex items-center">
        <div className="flex flex-col items-start w-[149px] mr-[32px]">
          <span className="mb-[2px] text-[#F79009] text-xs font-medium font-Inter">
            {isTutor ? 'Tutor' : 'Student'}
          </span>

          <div className="w-full flex items-center">
            <Avatar
              src={classBanner.class_banner_creator.profile_picture}
              gender={classBanner.class_banner_creator.gender}
              className="w-[24px] h-[24px] mr-[8px]"
            />

            <span className="w-full text-sm font-bold text-[#F67443] font-Inter text-ellipsis whitespace-nowrap overflow-hidden">
              {getUserName(
                classBanner.class_banner_creator,
                classBanner.creator_profile?.display_name,
                classBanner.creator_profile?.display_last_name
              )}
            </span>
          </div>
        </div>

        <div className="flex flex-col items-start w-[149px] mr-[32px]">
          <span className="mb-[2px] text-[#F79009] text-xs font-medium font-Inter">Date ended</span>

          <span className="w-full text-sm font-normal text-[#F67443] font-Inter text-ellipsis whitespace-nowrap overflow-hidden">
            {moment(pastClass.availability_calendar.day).format('MMMM DD, YYYY')}
          </span>
        </div>

        <div className="flex items-center gap-x-[10px]">
          {isTutor ? (
            <button className="w-[148px] rounded-[8px] bg-primary-button hover:bg-primary-button-hover px-[14px] h-[32px] shadow-button flex items-center justify-center text-sm font-semibold text-white font-Inter transition-colors duration-200 ease">
              Class Notes
            </button>
          ) : (
            <>
              <button className="rounded-[8px] border-[#F79009] border-[1px] bg-white hover:!bg-primary-button-hover hover:text-white hover:!border-primary-button-hover px-[14px] h-[32px] shadow-button flex items-center justify-center text-sm font-semibold text-[#F79009] font-Inter transition-colors duration-200 ease">
                Book Again
              </button>

              <button className="rounded-[8px] bg-primary-button hover:bg-primary-button-hover px-[14px] h-[32px] shadow-button flex items-center justify-center text-sm font-semibold text-white font-Inter transition-colors duration-200 ease">
                Message
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PastClass
